<p-toast></p-toast>
<p-confirmPopup></p-confirmPopup>

<div class="ajt">
  <app-drop-zone
    [showIcon]="true"
    [multiple]="true"
    [disabled]="!jobId || isFileUploading"
    label="Upload files"
    hint="Drag & drop files here, or"
    acceptHint="PDF, DOC, images, ZIP • up to 20 MB each"
    (filesSelected)="onFilesSelected($event)">
  </app-drop-zone>

  <p class="pp-empty-inline" *ngIf="isFileUploading">Uploading…</p>
  <p class="pp-empty-inline" *ngIf="loading">Loading attachments…</p>
  <p class="pp-empty-inline" *ngIf="!loading && !uploadedFiles.length">
    No attachments yet.
  </p>

  <ul class="ajt-list" *ngIf="!loading && uploadedFiles.length">
    <li class="ajt-row" *ngFor="let at of uploadedFiles; let i = index">
      <file-icon [type]="getIcon(at.originalFileName)" class="ajt-row__icon"></file-icon>
      <a
        class="ajt-row__name"
        [href]="at.url"
        target="_blank"
        rel="noopener"
        [attr.title]="at.originalFileName">
        {{ truncateFileName(at.originalFileName) }}
      </a>
      <span class="ajt-row__date">{{ at.uploadedDate | date: 'dd/MM/yyyy' }}</span>
      <div class="ajt-row__actions">
        <button type="button" class="pp-link-btn" (click)="download(at)">Download</button>
        <button type="button" class="pp-btn pp-btn--ghost pp-btn--icon" aria-label="Rename" (click)="renameAttachment(i)">
          <i class="pi pi-pencil"></i>
        </button>
        <button type="button" class="pp-btn pp-btn--ghost pp-btn--icon" aria-label="Remove" (click)="removeFile($event, i)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </li>
  </ul>
</div>

<p-dialog
  header="Rename Attachment"
  showEffect="fade"
  [modal]="true"
  [draggable]="false"
  [(visible)]="renameAttachmentDialog"
  [breakpoints]="{ '991px': '90vw' }"
  [style]="{ width: '35vw' }">
  <form [formGroup]="renameAttachmentForm">
    <div class="field">
      <label htmlFor="fileExtension" class="mr-4">File Name</label>
      <div class="flex flex-row pr-2">
        <input
          formControlName="fileName"
          pInputText
          type="text"
          placeholder="Enter File Name"
          class="w-full" />
        <input
          formControlName="fileExtension"
          pInputText
          type="text"
          class="w-20" />
      </div>
      <p
        class="text-red-400 text-sm"
        *ngIf="renameAttachmentFormErrors?.fileName?.required">
        File Name is required
      </p>
      <p
        class="text-red-400 text-sm"
        *ngIf="renameAttachmentFormErrors?.fileName?.error">
        Don't use "." or "/"
      </p>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="flex justify-end w-full">
      <button
        pButton
        pRipple
        icon="pi pi-check"
        label="Save"
        (click)="renameAttachmentSave()"
        [disabled]="renameAttachmentForm.invalid"></button>
    </div>
  </ng-template>
</p-dialog>
